module.exports = __webpack_public_path__ + "img/P150T_weapon_109.c7fffa92.png";